import React, { useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import { d as _taggedTemplateLiteral, k as _defineProperty, _ as _slicedToArray, a as _objectSpread2, c as _extends$1, n as _typeof, m as _toConsumableArray } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled from 'styled-components';
import { s as styleInject, K as KEY_CODES, u as useActivify, P as Portal$3, T as Tooltip, W as WithTooltip } from './withTooltip-92e0dfed.js';
import space from '@styled-system/space';
import color from '@styled-system/color';
import border from '@styled-system/border';
import variant from '@styled-system/variant';
import typography from '@styled-system/typography';
import { I as Icon, g as TickIcon, C as CloseIcon, f as AngleDownIcon, S as SearchIcon } from './index-28a062d6-3659b895.js';
import { C as Context } from './index-155df85b-a520c7f0.js';
import { r as rgba } from './generic-7099c3ed-1383f6f8.js';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import { c as cc, a as Label, i as inputStyle, b as TextInput, T as Text$1 } from './index-5dfda37f-a2c0763c.js';
import { c as createCommonjsModule, u as unwrapExports, F as Fuse } from './fuse-b0dfead8-7a3d565d.js';

var _templateObject;
var checkboxWrapperItem = variant({
  prop: "mode",
  scale: "checkboxItemWrapperModes",
  variants: {
    inline: {}
  }
});

// Non customizable CSS props
var checkboxItemStyle = function checkboxItemStyle(props) {
  return {
    alignItems: "center",
    cursor: !props.disabled && "pointer",
    pointerEvents: props.disabled && "none",
    "&:last-child": {
      marginBottom: 0
    }
  };
};
var ThemedCheckboxItemWrapper = styled(Box)(checkboxItemStyle, checkboxWrapperItem);
var iff = function iff(condition, then, otherwise) {
  return condition ? then : otherwise;
};
var checkboxItem = variant({
  scale: "checkboxVariants",
  variants: {}
});

// Non customizable CSS props
var checkboxStyle = function checkboxStyle(props) {
  return {
    justifyContent: "center",
    alignItems: "center",
    transition: "background-color 0.2s ease-out",
    backgroundColor: props.value ? iff(props.disabled, props.theme.colors.grey.deep, props.theme.colors.blue.haptik) : props.theme.colors.background,
    width: 18,
    height: 18,
    marginRight: props.theme.space.sm,
    borderRadius: props.theme.space.xs,
    borderWidth: props.theme.borderWidths.xs,
    borderColor: props.disabled ? props.theme.colors.grey.deep : props.theme.colors.blue.haptik,
    padding: 0
  };
};
var ThemedCheckbox = styled(Box)(checkboxStyle, checkboxItem);
var ThemedCheckboxIcon = styled(Icon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  opacity: ", ";\n  transform: translateY(", ");\n  transition: 0.2s ease-out;\n  svg * {\n    stroke: #eaeaea;\n    stroke-width: 2px;\n  }\n"])), function (props) {
  return props.value ? 1 : 0;
}, function (props) {
  return props.value ? "0px" : "5px";
});
var ThemedCheckboxItem = function ThemedCheckboxItem(props) {
  var label = props.label,
    onChange = props.onChange,
    value = props.value,
    disabled = props.disabled,
    mode = props.mode;
  return /*#__PURE__*/React.createElement(ThemedCheckboxItemWrapper, {
    disabled: disabled,
    mode: mode,
    onClick: function onClick(e) {
      return onChange(!value, e);
    }
  }, /*#__PURE__*/React.createElement(ThemedCheckbox, {
    disabled: disabled,
    value: value
  }, /*#__PURE__*/React.createElement(ThemedCheckboxIcon, {
    value: value,
    src: TickIcon
  })), /*#__PURE__*/React.createElement(Text, {
    variant: "body.md"
  }, label));
};
ThemedCheckboxItem.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool,
  disabled: PropTypes.string,
  mode: PropTypes.string
};
ThemedCheckboxItem.defaultProps = {
  mode: "inline"
};
ThemedCheckboxItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ThemedCheckboxItem",
  "props": {
    "mode": {
      "defaultValue": {
        "value": "\"inline\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z = ".CheckboxOption_checkboxOption__2dioS {\n  display: flex;\n  align-items: center;\n  margin-right: 24px;\n  cursor: pointer; }\n  .CheckboxOption_checkboxOption__2dioS:hover svg path {\n    fill: rgba(18, 79, 160, 0.1); }\n  .CheckboxOption_checkboxOption__2dioS.CheckboxOption_disabled__3DN5D {\n    filter: grayscale(1);\n    pointer-events: none;\n    opacity: 0.8; }\n\n.CheckboxOption_checkboxOptionBox__1g3RA {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n  border-radius: 4px;\n  border: 1px solid #666;\n  transition: 0.2s ease-out; }\n\n.CheckboxOption_checkboxOptionBoxTick__1ah4m {\n  width: 12px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transform: translateY(5px);\n  transition: 0.2s ease-out; }\n  .CheckboxOption_checkboxOptionBoxTick__1ah4m svg * {\n    stroke: #fff;\n    stroke-width: 2px; }\n  .CheckboxOption_checkboxOptionBoxTick__1ah4m.CheckboxOption_selected__3DFYX {\n    opacity: 1;\n    transform: translateY(0px); }\n\n.CheckboxOption_checkboxOptionText__qiLTY {\n  font-size: 14px;\n  font-weight: 400;\n  transition: 0.2s ease-out;\n  color: #666; }\n";
var styles = {"checkboxOption":"CheckboxOption_checkboxOption__2dioS","disabled":"CheckboxOption_disabled__3DN5D","checkboxOptionBox":"CheckboxOption_checkboxOptionBox__1g3RA","checkboxOptionBoxTick":"CheckboxOption_checkboxOptionBoxTick__1ah4m","selected":"CheckboxOption_selected__3DFYX","checkboxOptionText":"CheckboxOption_checkboxOptionText__qiLTY"};
styleInject(css_248z);

var CheckboxOption = function CheckboxOption(props) {
  var label = props.label,
    onChange = props.onChange,
    value = props.value,
    innerRef = props.innerRef,
    className = props.className,
    prefixClassName = props.prefixClassName,
    disabled = props.disabled;
  if (props.themed) {
    return /*#__PURE__*/React.createElement(ThemedCheckboxItem, props);
  }
  var _React$useContext = React.useContext(Context),
    primaryColor = _React$useContext.primaryColor;
  var classNames = {
    main: cc([styles.checkboxOption, className, prefixClassName, _defineProperty({}, styles.disabled, disabled), _defineProperty({}, styles.selected, value), _defineProperty({}, styles.selected, "".concat(prefixClassName, "-selected"))]),
    box: cc([styles.checkboxOptionBox, "".concat(prefixClassName, "-box")]),
    boxIcon: cc([styles.checkboxOptionBoxTick, "".concat(prefixClassName, "-box-tick"), _defineProperty({}, styles.selected, value)]),
    label: cc([styles.checkboxOptionText, "".concat(prefixClassName, "-text")])
  };
  var colorStyles = {
    box: value ? {
      background: primaryColor,
      borderColor: primaryColor
    } : {},
    label: value ? {
      color: primaryColor
    } : {}
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: innerRef,
    "data-testid": "checkbox-item",
    className: classNames.main,
    onClick: function onClick(e) {
      return onChange(!value, e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: colorStyles.box,
    className: classNames.box
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classNames.boxIcon,
    src: TickIcon
  })), /*#__PURE__*/React.createElement("span", {
    style: colorStyles.label,
    className: classNames.label
  }, label));
};
CheckboxOption.propTypes = {
  /** Label text */
  label: PropTypes.string,
  /** The classname to appended to the outermost element */
  className: PropTypes.string,
  /** onChange callback */
  onChange: PropTypes.func,
  /** The value of the input */
  value: PropTypes.bool,
  /** For assigning a ref to the outermost element */
  innerRef: PropTypes.func,
  /** The prefix classname appended to all elements */
  prefixClassName: PropTypes.string,
  /** Whether the input is enabled or disabled */
  disabled: PropTypes.string,
  themed: PropTypes.bool
};
CheckboxOption.defaultProps = {
  label: "",
  className: "",
  onChange: function onChange() {},
  value: false,
  innerRef: function innerRef() {},
  prefixClassName: "",
  disabled: false,
  themed: false
};
CheckboxOption.classNames = {
  $prefix: "Outermost element",
  "$prefix-box": "Div wrapping the icon",
  "$prefix-box-tick": "The icon div",
  "$prefix-text": "The Text of each of the checkbox options"
};
CheckboxOption.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckboxOption",
  "props": {
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label text"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to appended to the outermost element"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onChange callback"
    },
    "value": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "The value of the input"
    },
    "innerRef": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "For assigning a ref to the outermost element"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The prefix classname appended to all elements"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Whether the input is enabled or disabled"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$1 = ".Checkbox_checkbox__niF5T {\n  position: relative; }\n\n.Checkbox_checkboxLabel__2Ydkg {\n  display: block;\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 0px;\n  margin-left: 2px;\n  transition: 0.2s ease-out; }\n\n.Checkbox_checkboxHint__1Djyt {\n  display: block;\n  color: #999;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 12px;\n  margin-left: 2px;\n  transition: 0.2s ease-out; }\n\n.Checkbox_checkboxOptions__3YnsQ {\n  display: flex;\n  margin-left: 2px; }\n";
var styles$1 = {"checkbox":"Checkbox_checkbox__niF5T","checkboxLabel":"Checkbox_checkboxLabel__2Ydkg","checkboxHint":"Checkbox_checkboxHint__1Djyt","checkboxOptions":"Checkbox_checkboxOptions__3YnsQ"};
styleInject(css_248z$1);

function useCheckbox(value, onChange, options) {
  var getIndexes = function getIndexes() {
    var activeIds = value.map(function (valueItem) {
      return valueItem.title;
    });
    var activeIndexes = [];
    options.map(function (option, i) {
      if (activeIds.includes(option.title)) {
        activeIndexes.push(i);
      }
    });
    return activeIndexes;
  };
  var activeIndexes = getIndexes();
  var handleChange = function handleChange(index) {
    return function () {
      var indexPosition = activeIndexes.indexOf(index);
      if (indexPosition > -1) activeIndexes.splice(indexPosition, 1);else activeIndexes.push(index);
      onChange(activeIndexes.map(function (activeIndex) {
        return options[activeIndex];
      }));
    };
  };
  return [activeIndexes, handleChange];
}

var CheckboxWrapperMode = variant({
  prop: "mode",
  scale: "checkboxWrapperModes",
  variants: {
    stacked: {}
  }
});
var checkboxWrapperVariant = variant({
  prop: "variant",
  scale: "checkboxWrapperVariants",
  variants: {
    stacked: {}
  }
});
var ThemedCheckboxWrapper = styled(Box)(CheckboxWrapperMode, checkboxWrapperVariant);
ThemedCheckboxWrapper.defaultProps = {
  mode: "stacked",
  padding: "zero"
};

var Checkbox = function Checkbox(props) {
  var value = props.value,
    onChange = props.onChange,
    options = props.options,
    label = props.label,
    hint = props.hint,
    disabled = props.disabled,
    className = props.className,
    prefixClassName = props.prefixClassName,
    error = props.error;
  var _useCheckbox = useCheckbox(value, onChange, options),
    _useCheckbox2 = _slicedToArray(_useCheckbox, 2),
    activeIndexes = _useCheckbox2[0],
    handleChange = _useCheckbox2[1];
  if (props.themed) {
    var checkboxProps = _objectSpread2(_objectSpread2({}, props), {}, {
      "data-testid": "checkbox"
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Label, {
      hint: hint,
      disabled: disabled,
      error: error,
      themed: true
    }, label), /*#__PURE__*/React.createElement(ThemedCheckboxWrapper, _extends$1({}, checkboxProps, {
      variant: label ? "withLabel" : "default"
    }), props.options.map(function (option, i) {
      return /*#__PURE__*/React.createElement(ThemedCheckboxItem, {
        value: activeIndexes.includes(i),
        onChange: handleChange(i),
        label: option.title,
        error: error,
        themed: props.themed,
        mode: props.mode,
        disabled: disabled,
        prefixClassName: "".concat(prefixClassName, "-option")
      });
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "checkbox",
    className: "".concat(styles$1.checkbox, " ").concat(className, " ").concat(prefixClassName)
  }, /*#__PURE__*/React.createElement(Label, {
    hint: hint,
    disabled: disabled,
    error: error,
    className: "".concat(styles$1.dropdownLabel, " ").concat(prefixClassName, "-label")
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.checkboxOptions, " ").concat(prefixClassName, "-options")
  }, options.map(function (option, i) {
    return /*#__PURE__*/React.createElement(CheckboxOption, {
      value: activeIndexes.includes(i),
      onChange: handleChange(i),
      label: option.title,
      error: error,
      disabled: disabled,
      prefixClassName: "".concat(prefixClassName, "-option")
    });
  })));
};
Checkbox.propTypes = {
  /** The classname to appended to the outermost element */
  className: PropTypes.string,
  /** The hint text that shows up below the label */
  hint: PropTypes.string,
  /** Label text */
  label: PropTypes.string,
  /** If the input has an error. */
  error: PropTypes.bool,
  /** The prefix classname appended to all elements */
  prefixClassName: PropTypes.string,
  // Themed props
  /** onChange callback */
  onChange: PropTypes.func,
  /** The value of the input */
  value: PropTypes.string,
  /** Array of options (checkboxes) */
  options: PropTypes.array,
  /** If the input is disabled (non-editable) */
  disabled: PropTypes.bool,
  /** Mode to align checkboxes vertically or horizontally */
  mode: PropTypes.string,
  themed: PropTypes.bool
};
Checkbox.defaultProps = {
  className: "",
  hint: "",
  value: "",
  label: "",
  error: false,
  onChange: function onChange() {},
  prefixClassName: "",
  options: [],
  disabled: false,
  mode: "stacked",
  themed: false
};
Checkbox.classNames = {
  $prefix: "Outermost element",
  "$prefix-label": "Label of the input",
  "$prefix-options": "Div wrapping all the options",
  "$prefix-option": "Div wrapping the option",
  "$prefix-option-box": "Div wrapping the icon",
  "$prefix-option-box-tick": "The icon div inside the box",
  "$prefix-option-text": "The Text of each of the checkbox options"
};
Checkbox.Item = CheckboxOption;
Checkbox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Checkbox",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to appended to the outermost element"
    },
    "hint": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The hint text that shows up below the label"
    },
    "value": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The value of the input"
    },
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label text"
    },
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If the input has an error."
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onChange callback"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The prefix classname appended to all elements"
    },
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Array of options (checkboxes)"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If the input is disabled (non-editable)"
    },
    "mode": {
      "defaultValue": {
        "value": "\"stacked\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Mode to align checkboxes vertically or horizontally"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

var ENDPOINTS = {
  BASE_URL: '/mogambo_api',
  POLICY_ENDPOINT: '/generate_s3_policy/',
  SYNTHESIS_ENDPOINT: '/integration/voice/synthesize'
};

var IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif"];
var VIDEO_EXTENSIONS = ["mp4", "avi", "mpeg", "mov", "wmv"];
var AUDIO_EXTENSIONS = ["mpeg", "ogg"];

var AutosizeInput_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(React.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;
});

var AutosizeInput = unwrapExports(AutosizeInput_1);

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CloseV3Icon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 1a6 6 0 00-6 6h1a5 5 0 015-5V1zm6 6a6 6 0 00-6-6v1a5 5 0 015 5h1zm-6 6a6 6 0 006-6h-1a5 5 0 01-5 5v1zM1 7a6 6 0 006 6v-1a5 5 0 01-5-5H1zm0 0a6 6 0 016-6V0a7 7 0 00-7 7h1zm6 6a6 6 0 01-6-6H0a7 7 0 007 7v-1zm6-6a6 6 0 01-6 6v1a7 7 0 007-7h-1zM7 1a6 6 0 016 6h1a7 7 0 00-7-7v1z",
  fill: "#1B1B1B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.357 4.643L4.643 9.357M9.357 9.357L4.643 4.643",
  stroke: "#1B1B1B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

var ChipWrapperMode = variant({
  prop: "mode",
  scale: "chipWrapperModes",
  variants: {
    chipAdded: {}
  }
});
var ChipWrapperVariant = variant({
  prop: "variant",
  scale: "chipWrapperVariants",
  variants: {
    chipAdded: {}
  }
});

// Non customizable CSS props
var inputWrapperStyle = function inputWrapperStyle(props) {
  return {
    borderRadius: props.theme.radii.sm,
    border: "".concat(props.theme.borderWidths.xs, "px solid ").concat(props.theme.colors.grey.haptik),
    backgroundColor: props.theme.colors.grey.pastel,
    boxSizing: "border-box",
    width: "100%",
    transition: "border 0.3s ease, color 0.3s ease",
    outline: "none",
    "&:focus": {
      border: "".concat(props.theme.borderWidths.xs, "px solid ").concat(props.theme.colors.blue.haptik)
    },
    "&:hover": {
      border: "".concat(props.theme.borderWidths.xs, "px solid ").concat(props.theme.colors.blue.haptik)
    },
    position: "relative"
  };
};
var chipStyle = function chipStyle(props) {
  return {
    position: "relative",
    fontSize: props.theme.fontSizes[1],
    border: "".concat(props.theme.borderWidths.xs, "px solid ").concat(props.theme.colors.grey.haptik),
    backgroundColor: props.theme.colors.grey.neon,
    borderRadius: props.theme.radii.lg,
    padding: "2px 6px",
    marginRight: 6,
    marginBottom: 6,
    display: "flex",
    alignItems: "center"
  };
};
var ThemedChipsInputWrapper = styled("div")(inputWrapperStyle, space, color, border, typography, ChipWrapperMode, ChipWrapperVariant);
var chipsContainerStyle = function chipsContainerStyle(props) {
  return {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    cursor: "text",
    width: "100%",
    "&:not(:first-child)": {
      paddingLeft: 3 * props.theme.space.lg - props.theme.space.md // 38px
    }
  };
};

var ThemedChipsContainer = styled("div")(chipsContainerStyle, space, color, border, typography);
var ThemedChip = styled("div")(chipStyle, space, color, border, typography);

// Customizable CSS props
ThemedChipsInputWrapper.defaultProps = {
  fontFamily: "\"Proxima Nova\", sans-serif",
  mode: "default",
  variant: "default"
};
ThemedChipsContainer.defaultProps = {
  fontFamily: "\"Proxima Nova\", sans-serif",
  mode: "default",
  variant: "default"
};

var css_248z$2 = ".ChipsInput_chips__f7CZh {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fff;\n  padding: 4px;\n  padding-right: 8px;\n  min-height: 35px;\n  box-sizing: border-box;\n  cursor: pointer;\n  outline: none;\n  transition: 0.2s ease-out; }\n  .ChipsInput_chips__f7CZh.ChipsInput_error__2U5k8 {\n    border-color: #f44336;\n    background-color: rgba(244, 67, 54, 0.05); }\n\n.ChipsInput_chipsTrack__zpfVc {\n  margin-bottom: -6px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  cursor: text;\n  width: 100%; }\n\n.ChipsInput_chip__37cGX {\n  display: inline-block;\n  font-size: 12px;\n  border: 1px solid #ddd;\n  background-color: #f2f2f2;\n  color: #333333;\n  border-radius: 8px;\n  padding: 2px 8px;\n  margin-right: 6px;\n  margin-bottom: 6px;\n  display: flex;\n  align-items: center; }\n  .ChipsInput_chip__37cGX svg circle {\n    transition: 0.2s ease-out; }\n  .ChipsInput_chip__37cGX:hover {\n    background-color: rgba(238, 238, 239, 0.2); }\n\n.ChipsInput_deleteChipIcon__2jkAs {\n  margin-left: 6px;\n  width: 18px;\n  height: 18px;\n  cursor: pointer; }\n\n.ChipsInput_themedNewChip__3Atgq {\n  border: none;\n  font-family: \"Proxima Nova\", sans-serif;\n  outline: none; }\n  .ChipsInput_themedNewChipAdded__3rYKv {\n    margin-bottom: 6px; }\n\n.ChipsInput_newChip__3lTpD {\n  margin-right: 6px;\n  margin-bottom: 6px;\n  border: none;\n  padding: 4px 8px;\n  padding-left: 0;\n  line-height: 14px;\n  outline: none;\n  min-width: 80px;\n  font-size: 12px; }\n  .ChipsInput_newChip__3lTpD:focus {\n    border: none; }\n  .ChipsInput_newChip__3lTpD::placeholder {\n    color: #aaa; }\n\n.ChipsInput_disabled__2aL9V {\n  pointer-events: none;\n  cursor: not-allowed; }\n";
var styles$2 = {"chips":"ChipsInput_chips__f7CZh","error":"ChipsInput_error__2U5k8","chipsTrack":"ChipsInput_chipsTrack__zpfVc","chip":"ChipsInput_chip__37cGX","deleteChipIcon":"ChipsInput_deleteChipIcon__2jkAs","themedNewChip":"ChipsInput_themedNewChip__3Atgq","themedNewChipAdded":"ChipsInput_themedNewChipAdded__3rYKv","newChip":"ChipsInput_newChip__3lTpD","disabled":"ChipsInput_disabled__2aL9V"};
styleInject(css_248z$2);

function useChips(value, inputValue, onChange, setInputValue) {
  var addChip = function addChip(newChipValue) {
    // when the value is a simple array
    if (!value.includes(newChipValue) && newChipValue) {
      var newValue = value.concat([newChipValue]);
      onChange(newValue);
      setInputValue("");
    }
  };
  var deleteChip = function deleteChip(indexToDelete) {
    var newValue = value.filter(function (_, i) {
      return i !== indexToDelete;
    });
    onChange(newValue);
  };
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode) {
      case KEY_CODES.ENTER:
        addChip(e.target.value);
        break;
      case KEY_CODES.ESC:
        break;
      case KEY_CODES.BACKSPACE:
        if (!inputValue) {
          deleteChip(value.length - 1);
        }
        break;
    }
  };
  return [handleKeyDown, addChip, deleteChip];
}

var ChipsInput = function ChipsInput(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$onMouseDown = _ref.onMouseDown,
    onMouseDown = _ref$onMouseDown === void 0 ? function () {} : _ref$onMouseDown,
    _ref$innerRef = _ref.innerRef,
    innerRef = _ref$innerRef === void 0 ? /*#__PURE__*/React.createRef() : _ref$innerRef,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$focused = _ref.focused,
    focused = _ref$focused === void 0 ? false : _ref$focused,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? "" : _ref$error,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Type here..." : _ref$placeholder,
    inputRef = _ref.inputRef,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onType = _ref.onType,
    onType = _ref$onType === void 0 ? function () {} : _ref$onType,
    _ref$prefixComponent = _ref.prefixComponent,
    prefixComponent = _ref$prefixComponent === void 0 ? null : _ref$prefixComponent,
    _ref$postfixComponent = _ref.postfixComponent,
    postfixComponent = _ref$postfixComponent === void 0 ? null : _ref$postfixComponent,
    _ref$optionKey = _ref.optionKey,
    optionKey = _ref$optionKey === void 0 ? "text" : _ref$optionKey,
    _ref$prefixClassName = _ref.prefixClassName,
    prefixClassName = _ref$prefixClassName === void 0 ? "" : _ref$prefixClassName,
    _ref$typeValue = _ref.typeValue,
    typeValue = _ref$typeValue === void 0 ? "" : _ref$typeValue,
    _ref$themed = _ref.themed,
    themed = _ref$themed === void 0 ? false : _ref$themed,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant;
  var _React$useContext = React.useContext(Context),
    primaryColor = _React$useContext.primaryColor;
  var focusedClassNameString = focused ? "focused" : "";
  var focusedStyle = focused ? {
    borderColor: primaryColor
  } : {};
  var errorClassName = error ? styles$2.error : "";
  var _useState = useState(typeValue),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useChips = useChips(value, inputValue, onChange, setInputValue),
    _useChips2 = _slicedToArray(_useChips, 3),
    onKeyDownChips = _useChips2[0],
    deleteChip = _useChips2[2];
  var handleDelete = React.useCallback(function (i) {
    return function (e) {
      e.stopPropagation();
      e.preventDefault();
      deleteChip(i);
    };
  });
  var handleChange = React.useCallback(function (e) {
    var value = e.target.value;
    setInputValue(value);
    onType(value);
  });
  var handleKeyDown = React.useCallback(function (e) {
    onKeyDownChips(e);
    onKeyDown(e);
  });
  var renderInput = function renderInput() {
    // Since an external plugin is used here, we are adding a class for themed chips input
    var className = !themed ? "".concat(styles$2.newChip, " ").concat(prefixClassName, "-input") : "".concat(styles$2.themedNewChip, " ").concat(value.length > 0 && styles$2.themedNewChipAdded);
    return /*#__PURE__*/React.createElement(AutosizeInput, {
      ref: inputRef,
      inputClassName: className,
      onKeyDown: handleKeyDown,
      onChange: handleChange,
      value: inputValue,
      placeholder: placeholder
    });
  };
  var renderChip = function renderChip(chip, i) {
    var title = _typeof(chip) === "object" ? chip[optionKey] : chip;
    if (themed) {
      return /*#__PURE__*/React.createElement(ThemedChip, {
        key: i
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "body.md"
      }, title), !disabled && /*#__PURE__*/React.createElement("div", {
        onMouseDown: handleDelete(i),
        style: {
          marginLeft: 8
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        src: CloseV3Icon,
        size: Icon.SIZES.SMALL
      })));
    }
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "".concat(styles$2.chip, " ").concat(prefixClassName, "-chip")
    }, title, !disabled && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, "-chip-icon"),
      onMouseDown: handleDelete(i)
    }, /*#__PURE__*/React.createElement(Icon, {
      src: CloseIcon,
      className: "".concat(styles$2.deleteChipIcon, " ").concat(prefixClassName, "-chip-icon-svg")
    })));
  };
  React.useEffect(function () {
    setInputValue(typeValue);
  }, [typeValue]);
  var renderChipsInput = function renderChipsInput() {
    if (themed) {
      var chipsPresent = value.length > 0;
      return /*#__PURE__*/React.createElement(ThemedChipsInputWrapper, {
        tabIndex: "-1",
        ref: innerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: onMouseDown,
        variant: variant,
        mode: chipsPresent ? "chipAdded" : "default"
      }, prefixComponent, /*#__PURE__*/React.createElement(ThemedChipsContainer, null, chipsPresent ? value.map(renderChip) : null, !disabled ? renderInput() : null), postfixComponent);
    }
    return /*#__PURE__*/React.createElement("div", {
      tabIndex: "-1",
      ref: innerRef,
      style: focusedStyle,
      className: "".concat(styles$2.chips, " ").concat(prefixClassName, " ").concat(errorClassName, " ").concat(className, " ").concat(focusedClassNameString),
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseDown: onMouseDown
    }, prefixComponent, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$2.chipsTrack, " ").concat(prefixClassName, "-chips")
    }, value.length > 0 ? value.map(renderChip) : null, !disabled ? renderInput() : null), postfixComponent);
  };
  return renderChipsInput();
};
ChipsInput.propTypes = {
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseDown: PropTypes.func,
  innerRef: PropTypes.object,
  className: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onType: PropTypes.func,
  focused: PropTypes.bool,
  error: PropTypes.bool,
  placeholder: PropTypes.string,
  optionKey: PropTypes.string,
  inputRef: PropTypes.object,
  prefixComponent: PropTypes.node,
  postfixComponent: PropTypes.node,
  prefixClassName: PropTypes.string,
  typeValue: PropTypes.string,
  themed: PropTypes.bool,
  variant: PropTypes.string
};
ChipsInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ChipsInput",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onKeyDown": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseDown": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "defaultValue": {
        "value": "React.createRef()",
        "computed": true
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "focused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "error": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "defaultValue": {
        "value": "\"Type here...\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onType": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "prefixComponent": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "postfixComponent": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "optionKey": {
      "defaultValue": {
        "value": "\"text\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "typeValue": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "variant": {
      "defaultValue": {
        "value": "\"default\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "inputRef": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

// some sensible defaults
var defaultFuseOptions = {
  shouldSort: true,
  threshold: 0.2,
  tokenize: true,
  matchAllTokens: true,
  findAllMatches: true,
  location: 0,
  distance: 50,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ["text"]
};

/**
 * The useSearch hook handles searching of options
 * It uses fuse.js to implement fuzzy search. Based on the text
 * it filters the options list.
 * @param {String}    text        the text to search
 * @param {Object[]}  options     the array of objects to search
 * @param {String[]}  searchKeys  the array of keys to search (inside the options)
 * @returns
 */
function useSearch(text, options, searchKeys) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    searchResults = _useState2[0],
    setSearchResults = _useState2[1];
  var _fuse = useRef();
  var setupSearch = function setupSearch() {
    var fuseOptions = _objectSpread2(_objectSpread2({}, defaultFuseOptions), {}, {
      keys: searchKeys ? searchKeys : defaultFuseOptions.keys
    });
    _fuse.current = new Fuse(options, fuseOptions);
    handleSearch(text);
  };
  var handleSearch = function handleSearch(searchTerm) {
    if (searchTerm.length === 0) {
      setSearchResults(options);
    } else {
      setSearchResults(_fuse.current.search(searchTerm));
    }
  };
  useEffect(function () {
    setupSearch();
  }, [options]);
  useEffect(function () {
    handleSearch(text);
  }, [text]);
  return searchResults;
}

var css_248z$3 = ".Dropdown_dropdown__3k3U0 {\n  position: relative;\n  outline: none; }\n\n.Dropdown_dropdownInput__3_ZM1 {\n  cursor: pointer; }\n  .Dropdown_dropdownInput__3_ZM1.Dropdown_reverse__2SQlO.focused {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px; }\n  .Dropdown_dropdownInput__3_ZM1.focused {\n    border-color: #124fa0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0; }\n  .Dropdown_dropdownInputIcon__1c3Xu {\n    min-width: 21px; }\n\n.Dropdown_textHint__3S0b8 {\n  display: block;\n  color: #999;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 8px;\n  margin-left: 2px;\n  margin-top: -6px;\n  transition: 0.2s ease-out; }\n\n.Dropdown_dropdownInputZeroState__2d1Ps {\n  display: block;\n  padding: 8px;\n  font-size: 14px;\n  opacity: 0.4; }\n\n.Dropdown_dropdownInputSubtext__z5trs {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 4px;\n  font-size: 12px;\n  position: absolute;\n  bottom: 0;\n  transform: translate3d(0, 100%, 0);\n  padding-top: 4px; }\n\n.Dropdown_dropdownInputSubtextError__1jQ6s {\n  color: #ff0c0c;\n  opacity: 0.8; }\n";
var styles$3 = {"dropdown":"Dropdown_dropdown__3k3U0","dropdownInput":"Dropdown_dropdownInput__3_ZM1","reverse":"Dropdown_reverse__2SQlO","dropdownInputIcon":"Dropdown_dropdownInputIcon__1c3Xu","textHint":"Dropdown_textHint__3S0b8","dropdownInputZeroState":"Dropdown_dropdownInputZeroState__2d1Ps","dropdownInputSubtext":"Dropdown_dropdownInputSubtext__z5trs","dropdownInputSubtextError":"Dropdown_dropdownInputSubtextError__1jQ6s"};
styleInject(css_248z$3);

var DropdownOptionsMode = variant({
  prop: "mode",
  scale: "dropdownOptionsModes",
  variants: {
    active: {},
    inactive: {}
  }
});
var DropdownOptionsVariant = variant({
  prop: "variant",
  scale: "dropdownOptionsVariant",
  variants: {
    withCheckbox: {}
  }
});

// If Dropdown opens at top when its towards bottom of the screen
var DropdownOptionsPositionVariant = variant({
  prop: "positionVariant",
  scale: "dropdownOptionsPositionVariant",
  variants: {
    top: {},
    "default": {}
  }
});
var DropdownOptionMode = variant({
  prop: "mode",
  scale: "dropdownOptionModes",
  variants: {
    disabled: {}
  }
});
var DropdownOptionSize = variant({
  prop: "size",
  scale: "dropdownOptionSize",
  variants: {
    small: {}
  }
});
var DropdownOptionVariant = variant({
  prop: "variant",
  scale: "dropdownOptionVariant",
  variants: {
    "default": {},
    selected: {}
  }
});
var DropdownWithCheckboxVariant = variant({
  prop: "variant",
  scale: "dropdownWithCheckboxInputVariants",
  variants: {
    disabled: {}
  }
});
var DropdownArrowMode = variant({
  prop: "mode",
  scale: "dropdownArrowModes",
  variants: {
    active: {}
  }
});
var DropdownIconMode = variant({
  prop: "mode",
  scale: "dropdownIconModes",
  variants: {
    withCheckbox: {}
  }
});
var DropdownCheckboxOptionsMode = variant({
  prop: "mode",
  scale: "dropdownCheckboxOptionsModes",
  variants: {
    withoutSearch: {}
  }
});
var DropdownCheckboxSearchWrapperMode = variant({
  prop: "mode",
  scale: "dropdownCheckboxSearchWrapperModes",
  variants: {
    withoutSearch: {}
  }
});

// Non customizable CSS props
var wrapperStyle = {
  position: "relative",
  outline: "none",
  boxSizing: "border-box"
};
var optionsOverlayStyle = {
  position: "absolute",
  zIndex: 1000000000,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
};
var optionsStyle = function optionsStyle(props) {
  return {
    position: "absolute",
    zIndex: 1000000001,
    maxHeight: "200px",
    overflowY: "auto",
    backgroundColor: "#fff",
    border: "1px solid ".concat(props.theme.colors.blue.haptik, "}"),
    boxSizing: "border-box",
    marginTop: "-1px",
    transition: "transform 0.3s ease, opacity 0.3s ease",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)"
  };
};
var optionStyle = function optionStyle(props) {
  return {
    padding: "5px 12px",
    minHeight: 30,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "background 0.3s ease",
    "&:hover": {
      background: "".concat(props.theme.colors.blue.pastel, "50")
    }
  };
};
var withCheckboxInputStyle = function withCheckboxInputStyle(props) {
  var inputStyles = _objectSpread2({}, inputStyle(props));
  inputStyles.padding = "7px 38px 7px 8px";
  return _objectSpread2({
    marginTop: 8,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }, inputStyles);
};
var DropdownIconStyle = {
  position: "absolute",
  top: 0,
  height: "100%",
  display: "flex",
  alignItems: "center",
  transition: "transform 0.3s ease"
};
var dropdownArrowStyle = function dropdownArrowStyle(props) {
  return _objectSpread2(_objectSpread2({}, DropdownIconStyle), {}, {
    right: props.theme.space.lg - props.theme.space.xs // 10px
  });
};

var dropdownIconStyle = function dropdownIconStyle(props) {
  return _objectSpread2(_objectSpread2({}, DropdownIconStyle), {}, {
    left: props.theme.space.lg - props.theme.space.xs // 10px
  });
};

var checkboxWrapperStyle = {
  maxHeight: 198,
  overflow: "hidden"
};
var checkboxSearchWrapperStyle = function checkboxSearchWrapperStyle(props) {
  return {
    position: "relative",
    padding: "".concat(props.theme.space.lg - props.theme.space.xs, "px ").concat(props.theme.space.md, "px ").concat(props.theme.space.lg - props.theme.space.xs, "px") // "10px 12px 10px",
  };
};

var checkboxOptionsWrapperStyle = function checkboxOptionsWrapperStyle(props) {
  return {
    position: "relative",
    maxHeight: "calc(100vh - 60px)",
    // Height of the Search Wrapper
    overflowY: "auto",
    padding: "".concat(props.theme.space.sm, "px ").concat(props.theme.space.zero, "px")
  };
};
var dropdownCheckboxSearchStyle = {
  position: "absolute",
  top: 15,
  left: 15,
  zIndex: 1,
  width: 25,
  height: 25,
  ">div": {
    width: "100%",
    height: "100%"
  }
};
var dropdownCreateTextStyle = function dropdownCreateTextStyle(props) {
  return {
    color: props.theme.colors.green.haptik,
    paddingRight: props.theme.space.xs
  };
};
var checkboxItemWrapperStyle = function checkboxItemWrapperStyle(props) {
  return {
    transition: "background 0.3s ease",
    cursor: "pointer",
    ">div:first-child": {
      background: "transparent",
      width: "100%",
      margin: props.theme.space.zero
    },
    "&:hover": {
      background: "".concat(props.theme.colors.blue.pastel, "50")
    }
  };
};
var DropdownWrapper = styled(Box)(wrapperStyle, space, color, border, typography);
var DropdownOptionsWrapper = styled(Box)(space, color, border, typography);
var DropdownOptionsOverlay = styled("div")(optionsOverlayStyle, space, color, border, typography);
var DropdownOptions = styled("div")(optionsStyle, space, color, border, typography, DropdownOptionsMode, DropdownOptionsVariant, DropdownOptionsPositionVariant);
var DropdownOption = styled("div")(optionStyle, space, color, border, typography, DropdownOptionMode, DropdownOptionVariant, DropdownOptionSize);
var DropdownWithCheckboxInput = styled("div")(withCheckboxInputStyle, space, color, border, typography, DropdownWithCheckboxVariant);
var DropdownArrow = styled("div")(dropdownArrowStyle, space, color, border, typography, DropdownArrowMode);
var DropdownIcon = styled(Box)(dropdownIconStyle, space, color, border, typography, DropdownIconMode);
var DropdownCheckboxWrapper = styled(Box)(checkboxWrapperStyle, space, color, border, typography, DropdownWithCheckboxVariant);
var DropdownCheckboxSearchWrapper = styled(Box)(checkboxSearchWrapperStyle, space, color, border, typography, DropdownCheckboxSearchWrapperMode);
var DropdownCheckboxOptionsWrapper = styled(Box)(checkboxOptionsWrapperStyle, space, color, border, typography, DropdownCheckboxOptionsMode);
var DropdownCheckboxItemWrapper = styled(Box)(checkboxItemWrapperStyle, space, color, border, typography);
var DropdownCheckboxSearchIcon = styled("div")(dropdownCheckboxSearchStyle, space, color, border, typography);
var DropdownCreateText = styled("span")(dropdownCreateTextStyle, space, color, border, typography);

// Customizable CSS props
DropdownWrapper.defaultProps = {
  fontFamily: "\"Proxima Nova\", sans-serif",
  padding: "zero",
  flexDirection: "column",
  width: "100%"
};
DropdownIcon.defaultProps = {
  padding: "zero"
};
DropdownOptionsWrapper.defaultProps = {
  fontFamily: "\"Proxima Nova\", sans-serif",
  padding: "zero",
  display: "initial"
};
DropdownCheckboxWrapper.defaultProps = {
  padding: "zero",
  display: "flex",
  flexDirection: "column"
};
DropdownCheckboxSearchWrapper.defaultProps = {
  display: "initial"
};
DropdownCheckboxOptionsWrapper.defaultProps = {
  padding: "zero",
  paddingBottom: "sm",
  display: "initial"
};
DropdownCheckboxItemWrapper.defaultProps = {
  paddingTop: "xs",
  paddingBottom: "xs",
  paddingLeft: "sm",
  paddingRight: "sm"
};
DropdownOptions.defaultProps = {
  mode: "inactive"
};

var css_248z$1$1 = ".Option_dropdownOption__1rKJw {\n  padding: 8px;\n  font-family: \"Roboto\", sans-serif;\n  border-bottom: 1px solid rgba(221, 221, 221, 0.4); }\n  .Option_dropdownOption__1rKJw:first-child {\n    padding-top: 8px; }\n  .Option_dropdownOption__1rKJw:hover {\n    background-color: #fafafa;\n    cursor: pointer; }\n  .Option_dropdownOption__1rKJw.Option_zeroState__1Z7KT {\n    opacity: 0.5;\n    background-color: transparent !important; }\n    .Option_dropdownOption__1rKJw.Option_zeroState__1Z7KT span {\n      color: #000 !important; }\n  .Option_dropdownOption__1rKJw.Option_isNew__1eOC1 span {\n    font-style: italic; }\n\n.Option_dropdownOptionText__1-Ndm {\n  font-size: 12px;\n  font-weight: 400; }\n";
var styles$1$1 = {"dropdownOption":"Option_dropdownOption__1rKJw","zeroState":"Option_zeroState__1Z7KT","isNew":"Option_isNew__1eOC1","dropdownOptionText":"Option_dropdownOptionText__1-Ndm"};
styleInject(css_248z$1$1);

var Option = function Option(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    selected = _ref.selected,
    innerRef = _ref.innerRef,
    className = _ref.className,
    isZeroState = _ref.isZeroState,
    isNew = _ref.isNew,
    themed = _ref.themed,
    noOptionsText = _ref.noOptionsText,
    checkboxSearch = _ref.checkboxSearch,
    size = _ref.size,
    onMouseDown = _ref.onMouseDown;
  var _React$useContext = React.useContext(Context),
    primaryColor = _React$useContext.primaryColor;
  var dropdownOptionSelectedStyle = selected ? {
    backgroundColor: rgba(primaryColor, 0.1)
  } : {};
  var dropdownOptionTextStyle = selected ? {
    color: primaryColor
  } : {};
  var selectedClassName = selected ? "".concat(className, "-selected") : "";
  var zeroStateClassName = isZeroState ? styles$1$1.zeroState : "";
  var isNewClassName = isNew ? styles$1$1.isNew : "";
  var optionMode = "default";
  var renderOption = function renderOption() {
    if (themed) {
      if (children === noOptionsText) {
        if (checkboxSearch) {
          optionMode = "disabledWithCheckboxSearch";
        } else {
          optionMode = "disabled";
        }
      }
      return /*#__PURE__*/React.createElement(DropdownOption, {
        ref: innerRef,
        onMouseDown: onMouseDown,
        onClick: !isZeroState ? onClick : null,
        "data-testid": "dropdown-option",
        mode: optionMode,
        size: size,
        variant: selected && children !== noOptionsText ? "selected" : "default"
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "body.md",
        color: children === noOptionsText && "red.haptik"
      }, children));
    }
    return /*#__PURE__*/React.createElement("div", {
      ref: innerRef,
      style: dropdownOptionSelectedStyle,
      className: "".concat(styles$1$1.dropdownOption, " ").concat(className, " ").concat(selectedClassName, " ").concat(zeroStateClassName, " ").concat(isNewClassName),
      onMouseDown: onMouseDown,
      onClick: !isZeroState ? onClick : null,
      "data-testid": "dropdown-option"
    }, /*#__PURE__*/React.createElement("span", {
      style: dropdownOptionTextStyle,
      className: "".concat(styles$1$1.dropdownOptionText),
      dangerouslySetInnerHTML: {
        __html: children
      }
    }));
  };
  return renderOption();
};
Option.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  innerRef: PropTypes.func,
  isNew: PropTypes.bool,
  isZeroState: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  themed: PropTypes.bool,
  noOptionsText: PropTypes.string,
  onMouseDown: PropTypes.func
};
Option.defaultProps = {
  children: "",
  className: "",
  innerRef: function innerRef() {},
  onClick: function onClick() {},
  isNew: false,
  isZeroState: false,
  selected: false,
  themed: false,
  noOptionsText: "",
  onMouseDown: function onMouseDown() {}
};
Option.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Option",
  "props": {
    "children": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "isNew": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isZeroState": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "selected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "noOptionsText": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onMouseDown": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

/**
 * Handles the keyboard events for selection and navigation
 * of dropdown options. [Up/Down/Enter/Escape]
 * Also attaches/removes the event listener for keydown on the input
 * passed in the configuration
 * Returns the index of the option to be highlighted
 * @param {Object}    config
 * @param {Object[]}  config.options  List of all options
 * @param {function}  config.onEnter  onEnter callback
 * @param {function}  config.onEscape onEscape callback
 * @param {Object}    config.attachTo the dom ref to attach the listeners to
 * @param {boolean}   config.enabled  whether keyboard select is enabled
 * @returns {number}                  the higlight index of the selected option
 */
function useKeyboardSelect(_ref) {
  var options = _ref.options,
    onEnter = _ref.onEnter,
    onEscape = _ref.onEscape,
    attachTo = _ref.attachTo,
    enabled = _ref.enabled;
  /*
    highlightIndex = -1 so that by default no option is highligted
    once you press keydown or keyup first/last option will be highlighted 
  */
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    highlightIndex = _useState2[0],
    setHighlightIndex = _useState2[1];
  var changeHighlightIndex = function changeHighlightIndex(newIndex) {
    if (newIndex >= options.length) {
      newIndex = 0;
    } else if (newIndex < 0) {
      newIndex = options.length - 1;
    }
    setHighlightIndex(newIndex);
  };
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode) {
      case KEY_CODES.DOWN:
        e.preventDefault();
        e.stopPropagation();
        return changeHighlightIndex(highlightIndex + 1);
      case KEY_CODES.UP:
        e.preventDefault();
        e.stopPropagation();
        return changeHighlightIndex(highlightIndex - 1);
      case KEY_CODES.ENTER:
        e.preventDefault();
        e.stopPropagation();
        if (!options[highlightIndex] || options[highlightIndex].isZeroState) return onEscape(false);
        return onEnter(options[highlightIndex].value);
      case KEY_CODES.ESC:
        e.preventDefault();
        e.stopPropagation();
        return onEscape(false);
      default:
        return null;
    }
  };
  useEffect(function () {
    if (!attachTo.current || !enabled) return;
    attachTo.current.addEventListener("keydown", handleKeyDown);
    return function () {
      if (!attachTo.current) return;
      attachTo.current.removeEventListener("keydown", handleKeyDown);
    };
  }, [attachTo.current, highlightIndex, options, enabled]);
  return highlightIndex;
}

var css_248z$2$1 = ".Options_dropdownOptions__3ilMA {\n  position: absolute;\n  z-index: 1000000001;\n  width: 100px;\n  max-height: 200px;\n  overflow-y: scroll;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  opacity: 0;\n  box-sizing: border-box;\n  margin-top: -1px;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  transition: 0.1s ease-out;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); }\n  .Options_dropdownOptions__3ilMA.Options_active__2zBEj {\n    transform: translateY(0px);\n    opacity: 1; }\n  .Options_dropdownOptions__3ilMA.Options_reverse__Rwqvh {\n    box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.1);\n    border-top-right-radius: 8px;\n    border-top-left-radius: 8px;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n    .Options_dropdownOptions__3ilMA.Options_reverse__Rwqvh.Options_active__2zBEj {\n      transform: translateY(0px); }\n\n.Options_dropdownOptionsOverlay__14JOX {\n  position: absolute;\n  z-index: 1000000000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0; }\n\n.Options_checkboxOptions__uTTqu {\n  max-height: inherit;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column; }\n  .Options_checkboxOptionsSearch__1rPDL {\n    width: -webkit-fill-available;\n    font-size: 14px;\n    outline: none;\n    border: 0;\n    border-radius: 0;\n    padding: 4px; }\n    .Options_checkboxOptionsSearchWrapper__3iwLd {\n      display: flex;\n      margin: 12px;\n      border: 1px solid #ddd;\n      padding: 2px;\n      border-radius: 8px; }\n      .Options_checkboxOptionsSearchWrapper__3iwLd.Options_noBorder__tKYPc {\n        border: 0 !important;\n        margin-top: 0;\n        margin-bottom: 4px; }\n      .Options_checkboxOptionsSearchWrapperZeroState__27A2b {\n        padding: 12px;\n        padding-top: 0; }\n    .Options_checkboxOptionsSearchIcon__1u5RG {\n      margin-top: 2px; }\n      .Options_checkboxOptionsSearchIcon__1u5RG.Options_noDisplay__3CatW {\n        display: none; }\n    .Options_checkboxOptionsSearch__1rPDL.Options_hidden__NAqri {\n      opacity: 0 !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      max-height: 2px !important; }\n  .Options_checkboxOptionsWrapper__3ir0c {\n    overflow: auto; }\n  .Options_checkboxOptionsOption__aFmlz {\n    padding: 4px 12px;\n    margin: 0; }\n    .Options_checkboxOptionsOption__aFmlz:hover {\n      background-color: #fafafa;\n      cursor: pointer; }\n";
var styles$2$1 = {"dropdownOptions":"Options_dropdownOptions__3ilMA","active":"Options_active__2zBEj","reverse":"Options_reverse__Rwqvh","dropdownOptionsOverlay":"Options_dropdownOptionsOverlay__14JOX","checkboxOptions":"Options_checkboxOptions__uTTqu","checkboxOptionsSearch":"Options_checkboxOptionsSearch__1rPDL","checkboxOptionsSearchWrapper":"Options_checkboxOptionsSearchWrapper__3iwLd","noBorder":"Options_noBorder__tKYPc","checkboxOptionsSearchWrapperZeroState":"Options_checkboxOptionsSearchWrapperZeroState__27A2b","checkboxOptionsSearchIcon":"Options_checkboxOptionsSearchIcon__1u5RG","noDisplay":"Options_noDisplay__3CatW","hidden":"Options_hidden__NAqri","checkboxOptionsWrapper":"Options_checkboxOptionsWrapper__3ir0c","checkboxOptionsOption":"Options_checkboxOptionsOption__aFmlz"};
styleInject(css_248z$2$1);

var Options = function Options(_ref) {
  var options = _ref.options,
    _onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    attachTo = _ref.attachTo,
    focused = _ref.focused,
    inputRef = _ref.inputRef,
    prefixClassName = _ref.prefixClassName,
    isSearchFocused = _ref.isSearchFocused,
    handleOnSearchFocus = _ref.handleOnSearchFocus,
    handleOnSearchBlur = _ref.handleOnSearchBlur,
    handleSearchText = _ref.handleSearchText,
    isReversed = _ref.isReversed,
    withCheckbox = _ref.withCheckbox,
    withMultiple = _ref.withMultiple,
    withSearch = _ref.withSearch,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    className = _ref.className,
    themed = _ref.themed,
    noOptionsText = _ref.noOptionsText,
    size = _ref.size,
    onMouseDown = _ref.onMouseDown,
    attachPortalTo = _ref.attachPortalTo;
  var _useActivify = useActivify(focused),
    visible = _useActivify.visible,
    enabled = _useActivify.enabled;
  var _React$useContext = React.useContext(Context),
    primaryColor = _React$useContext.primaryColor;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dropdownContainerRect = _React$useState2[0],
    setDropdownContainerRect = _React$useState2[1];

  // A ref to store all the DOM elements for all the options
  var dropdownDOMs = React.useRef();

  // A ref for the options container (the scroll window)
  var scrollContainer = React.useRef();

  // Handles all keyboard selection (up/down/escape/enter)
  // returns the currently selected index
  // (the index of the option that needs to be highlighted)
  var highlightIndex = useKeyboardSelect({
    options: options,
    attachTo: attachTo,
    onEnter: _onChange,
    onEscape: onBlur,
    // only enabled when the options are actually visible
    enabled: visible
  });
  var activeClassName = visible ? styles$2$1.active : "";
  var focusedStyle = focused ? {
    borderColor: primaryColor
  } : {};
  var focusedSearchStyle = isSearchFocused ? {
    borderColor: primaryColor
  } : {};
  var reverseModeClassName = isReversed ? styles$2$1.reverse : "";

  // Calculates Rect dimensions of attachTo Ref
  var calcRect = useCallback(function () {
    var rect = attachTo.current && attachTo.current.getBoundingClientRect();
    setDropdownContainerRect(rect);
  }, [attachTo, setDropdownContainerRect]);

  /* Dropdown refs useEffect
   * whenever the options change
   * we create n refs where n is the number of options
   * we store these refs in the dropdownDOMs ref
   */
  React.useEffect(function () {
    dropdownDOMs.current = new Array(options.length).fill(0).map(function () {
      return /*#__PURE__*/React.createRef();
    });

    // Refresh the rect dimensions whenever there are changes in options
    calcRect();
  }, [options.length, options, highlightIndex, calcRect]);

  /* Dropdown options scrollIntoView useEffect
   * whenever the highlightIndex changes
   * if the new option is not visible in the options window
   * we scroll to the new option to ensure visibility
   * it tries to mimic how native dropdowns on the web work
   */
  React.useEffect(function () {
    var optionDOMS = dropdownDOMs.current || [];
    var activeOptionDOM = (optionDOMS[highlightIndex] || {}).current;
    var containerDOM = scrollContainer.current;
    if (!activeOptionDOM || !containerDOM) return;
    var containerHeight = containerDOM.getBoundingClientRect().height;
    var scrollStartPoint = containerDOM.scrollTop;
    var scrollEndPoint = scrollStartPoint + containerHeight;
    var elemOffset = activeOptionDOM.offsetTop;
    var elemHeight = activeOptionDOM.getBoundingClientRect().height;
    if (elemOffset + elemHeight > scrollEndPoint) {
      // if the element is past the visible point
      // then we scroll the dropdown just enouogh so that the element
      // is visible at the bottom of the dropdown
      containerDOM.scrollTop = elemOffset - containerHeight + elemHeight;
    } else if (elemOffset - elemHeight < scrollStartPoint) {
      // if the element is before the visible point
      // then we scroll the dropdown just enouogh so that the element
      // is visible at the top of the dropdown
      containerDOM.scrollTop = elemOffset;
    }
  }, [highlightIndex]);
  var handleScroll = useCallback(function () {
    // Refresh the rect dimensions whenever user scrolls the page
    calcRect();
  }, [calcRect]);
  React.useEffect(function () {
    themed && focused && window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, [themed, focused, handleScroll]);
  if (!enabled) return null;
  var getPosition = function getPosition() {
    var inputRect;
    if (inputRef && inputRef.current && !!inputRef.current.ownerDocument && inputRef.current instanceof inputRef.current.ownerDocument.defaultView.HTMLElement) {
      inputRect = inputRef.current.getBoundingClientRect();
    }
    var attachPortalToRect = attachPortalTo && attachPortalTo.current && attachPortalTo.current.getBoundingClientRect();
    return {
      top: isReversed ? undefined : attachPortalTo && attachPortalTo.current && inputRect ? inputRect.top - attachPortalToRect.top + inputRect.height : dropdownContainerRect.bottom + window.scrollY,
      bottom: isReversed ? attachPortalTo && attachPortalTo.current && inputRect ? attachPortalToRect.bottom - inputRect.bottom + inputRect.height - 1 : window.innerHeight - dropdownContainerRect.top - window.scrollY - 1 : undefined,
      left: attachPortalTo && attachPortalTo.current && inputRect ? inputRect.left - attachPortalToRect.left : dropdownContainerRect.left,
      width: dropdownContainerRect.width
    };
  };

  // based on if the dropdown options should show above (isReversed) or below
  // the input, we assign positional properties that will be applied to the outermost
  // options div.
  var position = getPosition();
  var checkboxWrapperVariant;
  if (focused) {
    if (isReversed) {
      checkboxWrapperVariant = "dropdownActiveTop";
    } else {
      checkboxWrapperVariant = "dropdownActive";
    }
  }
  var renderWithCheckbox = function renderWithCheckbox() {
    if (themed) {
      return /*#__PURE__*/React.createElement(DropdownCheckboxWrapper, {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        variant: checkboxWrapperVariant
      }, /*#__PURE__*/React.createElement(DropdownCheckboxSearchWrapper, {
        mode: withSearch ? "withSearch" : "withoutSearch"
      }, /*#__PURE__*/React.createElement(DropdownCheckboxSearchIcon, null, /*#__PURE__*/React.createElement(Icon, {
        src: SearchIcon
      })), /*#__PURE__*/React.createElement(Text$1, {
        themed: true,
        innerRef: inputRef,
        placeholder: "Search here",
        onChange: handleSearchText,
        onFocus: handleOnSearchFocus,
        onBlur: handleOnSearchBlur,
        style: {
          paddingLeft: 36
        }
      })), /*#__PURE__*/React.createElement(DropdownCheckboxOptionsWrapper, {
        mode: withSearch ? "default" : "withoutSearch"
      }, options.map(function (option, i) {
        if (option.isZeroState) {
          return /*#__PURE__*/React.createElement(Option, {
            key: "themed-".concat(option.label, "-").concat(i),
            selected: highlightIndex === i,
            innerRef: dropdownDOMs.current[i],
            isZeroState: option.isZeroState,
            themed: true,
            noOptionsText: noOptionsText,
            checkboxSearch: true
          }, option.label);
        }
        // TODO: Add "create mode" as and when required
        return /*#__PURE__*/React.createElement(DropdownCheckboxItemWrapper, null, /*#__PURE__*/React.createElement(Checkbox.Item, {
          themed: true,
          key: "themed-".concat(option.label, "-").concat(i),
          label: option.label,
          value: option.isSelected,
          onChange: function onChange() {
            _onChange(option.value);
          }
        }));
      })));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles$2$1.checkboxOptions,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$2$1.checkboxOptionsSearchWrapper, "  ").concat(!withSearch && styles$2$1.noBorder),
      style: {
        borderColor: focused ? primaryColor : undefined
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: SearchIcon,
      className: "".concat(styles$2$1.checkboxOptionsSearchIcon, " ").concat(prefixClassName, "-icon  ").concat(!withSearch && styles$2$1.noDisplay)
    }), /*#__PURE__*/React.createElement("input", {
      ref: inputRef,
      className: "".concat(styles$2$1.checkboxOptionsSearch, " ").concat(!withSearch && styles$2$1.hidden),
      style: focusedSearchStyle,
      placeholder: "Search here",
      onChange: function onChange(e) {
        return handleSearchText(e.target.value);
      },
      onFocus: handleOnSearchFocus,
      onBlur: handleOnSearchBlur
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$2$1.checkboxOptionsWrapper
    }, options.map(function (option, i) {
      if (option.isZeroState) {
        return /*#__PURE__*/React.createElement(Option, {
          key: "".concat(option.label, "-").concat(i),
          selected: highlightIndex === i,
          innerRef: dropdownDOMs.current[i],
          isZeroState: option.isZeroState,
          className: "".concat(prefixClassName, "-option ").concat(styles$2$1.checkboxOptionsWrapperZeroState)
        }, option.label);
      }
      // TODO: Add "create mode" as and when required
      return /*#__PURE__*/React.createElement(Checkbox.Item, {
        key: "".concat(option.label, "-").concat(i),
        label: option.label,
        value: option.isSelected,
        onChange: function onChange() {
          _onChange(option.value);
        },
        className: "".concat(styles$2$1.checkboxOptionsOption, " ").concat(prefixClassName, "-option")
      });
    })));
  };
  var renderOptionsInner = function renderOptionsInner() {
    if (withCheckbox && withMultiple) {
      return renderWithCheckbox();
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, options.map(function (option, i) {
      return /*#__PURE__*/React.createElement(Option, {
        key: "".concat(option.label, "-").concat(i),
        selected: highlightIndex === i,
        innerRef: dropdownDOMs.current[i],
        onClick: function onClick() {
          _onChange(option.value);
        },
        onMouseDown: onMouseDown,
        isZeroState: option.isZeroState,
        isNew: option.isNew,
        className: "".concat(prefixClassName, "-option"),
        themed: themed,
        noOptionsText: noOptionsText,
        size: size
      }, option.label);
    }));
  };
  var renderOptions = function renderOptions() {
    if (themed) {
      var mode = visible ? "active" : "inactive";
      return /*#__PURE__*/React.createElement(DropdownOptionsWrapper, null, /*#__PURE__*/React.createElement(DropdownOptionsOverlay, null), /*#__PURE__*/React.createElement(DropdownOptions, {
        ref: scrollContainer,
        style: _objectSpread2({}, position),
        onBlur: onBlur,
        mode: mode,
        variant: withCheckbox ? "withCheckbox" : "default",
        positionVariant: isReversed ? "top" : "default"
      }, renderOptionsInner()));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$2$1.dropdownOptionsWrapper, "  ").concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$2$1.dropdownOptionsOverlay
    }), /*#__PURE__*/React.createElement("div", {
      ref: scrollContainer,
      style: _objectSpread2(_objectSpread2({}, position), focusedStyle),
      className: "".concat(styles$2$1.dropdownOptions, " ").concat(activeClassName, " ").concat(reverseModeClassName, " ").concat(prefixClassName, "-options"),
      onBlur: onBlur
    }, renderOptionsInner()));
  };
  return /*#__PURE__*/React.createElement(Portal$3, {
    node: attachPortalTo && attachPortalTo.current
  }, renderOptions());
};
Options.propTypes = {
  prefixClassName: PropTypes.string,
  className: PropTypes.string,
  focused: PropTypes.bool,
  isReversed: PropTypes.bool,
  withCheckbox: PropTypes.bool,
  withMultiple: PropTypes.bool,
  withSearch: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  inputRef: PropTypes.shape({
    current: PropTypes.node
  }),
  attachTo: PropTypes.shape({
    current: PropTypes.node
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.shape({})
  })),
  isSearchFocused: PropTypes.bool,
  handleOnSearchFocus: PropTypes.func,
  handleOnSearchBlur: PropTypes.func,
  handleSearchText: PropTypes.func,
  themed: PropTypes.bool,
  noOptionsText: PropTypes.string,
  size: PropTypes.string,
  onMouseDown: PropTypes.func,
  attachPortalTo: PropTypes.shape({
    current: PropTypes.node
  })
};
Options.defaultProps = {
  prefixClassName: "",
  className: "",
  focused: false,
  isReversed: false,
  withCheckbox: false,
  withMultiple: false,
  isSearchFocused: false,
  withSearch: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  handleOnSearchFocus: function handleOnSearchFocus() {},
  handleOnSearchBlur: function handleOnSearchBlur() {},
  handleSearchText: function handleSearchText() {},
  options: [],
  attachTo: {},
  themed: false,
  noOptionsText: "",
  size: "",
  onMouseDown: function onMouseDown() {},
  attachPortalTo: null
};
Options.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Options",
  "props": {
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "focused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isReversed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withCheckbox": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withMultiple": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isSearchFocused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withSearch": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "handleOnSearchFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "handleOnSearchBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "handleSearchText": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "label": {
              "name": "string",
              "required": false
            },
            "value": {
              "name": "shape",
              "value": {},
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "attachTo": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "node",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "noOptionsText": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onMouseDown": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "attachPortalTo": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "node",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "inputRef": {
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "node",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$3$1 = ".Input_input__2jbcF.Input_focused__3kWvf:not(.Input_reversed__2ZoNG) {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.Input_input__2jbcF.Input_focused__3kWvf.Input_reversed__2ZoNG {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n";
var styles$3$1 = {"input":"Input_input__2jbcF","focused":"Input_focused__3kWvf","reversed":"Input_reversed__2ZoNG"};
styleInject(css_248z$3$1);

var Input = function Input(_ref) {
  var withMultiple = _ref.withMultiple,
    withSearch = _ref.withSearch,
    value = _ref.value,
    onChange = _ref.onChange,
    text = _ref.text,
    onTextChange = _ref.onTextChange,
    innerRef = _ref.innerRef,
    inputRef = _ref.inputRef,
    focused = _ref.focused,
    isReversed = _ref.isReversed,
    placeholder = _ref.placeholder,
    optionKey = _ref.optionKey,
    tooltip = _ref.tooltip,
    prefixClassName = _ref.prefixClassName,
    disabled = _ref.disabled,
    themed = _ref.themed,
    icon = _ref.icon,
    arrowIcon = _ref.arrowIcon,
    size = _ref.size;
  var focusedClassName = focused ? styles$3$1.focused : "";
  var reversedClassName = isReversed ? styles$3$1.reversed : "";
  var className = "".concat(styles$3$1.input, " ").concat(focusedClassName, " ").concat(reversedClassName);
  var dropdownClassName = "".concat(themed && styles$3$1.dropdownIcon, " ").concat(themed && focused && styles$3$1.dropdownIconActive);
  var postfixComponent = tooltip ? /*#__PURE__*/React.createElement(WithTooltip, {
    className: "".concat(prefixClassName, "-tooltip"),
    tooltip: tooltip,
    position: "BOTTOM"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "".concat(prefixClassName, "-icon"),
    src: AngleDownIcon
  })) : /*#__PURE__*/React.createElement(Icon, {
    className: "".concat(prefixClassName, "-icon ").concat(dropdownClassName),
    src: AngleDownIcon
  });
  var themedPostfixComponent = tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    themed: true,
    tooltip: tooltip,
    position: "BOTTOM"
  }, /*#__PURE__*/React.createElement(DropdownArrow, {
    mode: focused ? "active" : "inactive"
  }, arrowIcon || /*#__PURE__*/React.createElement(Icon, {
    src: AngleDownIcon
  }))) : /*#__PURE__*/React.createElement(DropdownArrow, {
    mode: focused ? "active" : "inactive"
  }, arrowIcon || /*#__PURE__*/React.createElement(Icon, {
    src: AngleDownIcon,
    size: size
  }));
  var prefixComponent = icon && /*#__PURE__*/React.createElement(DropdownIcon, null, /*#__PURE__*/React.createElement(Icon, {
    src: icon,
    size: size
  }));
  var dropdownVariant = "dropdown";
  if (focused) {
    if (isReversed) {
      dropdownVariant = "dropdownActiveTop";
    } else {
      dropdownVariant = "dropdownActive";
    }
  }
  var commonProps = {
    innerRef: innerRef,
    inputRef: inputRef,
    focused: focused,
    placeholder: placeholder,
    className: className,
    prefixClassName: prefixClassName,
    prefixComponent: prefixComponent,
    postfixComponent: themed ? themedPostfixComponent : postfixComponent,
    disabled: disabled,
    themed: themed,
    size: size,
    variant: dropdownVariant
  };

  // if multiple selection is allowed, then we use the chips input
  // which deals with multiple item selections (arrays)
  // TODO: add a size variant
  if (withMultiple) {
    return /*#__PURE__*/React.createElement(ChipsInput, _extends$1({
      value: value,
      typeValue: text,
      onChange: onChange,
      onType: onTextChange,
      optionKey: optionKey
    }, commonProps));
  }

  // if search is allowed, then we return an editable text input
  if (withSearch) {
    return /*#__PURE__*/React.createElement(TextInput, _extends$1({
      editable: true,
      value: text,
      onChange: onTextChange
    }, commonProps));
  }

  // otherwise we still return a text input
  // however editing is disabled
  return /*#__PURE__*/React.createElement(TextInput, _extends$1({
    editable: false,
    value: value[0][optionKey],
    onChange: onTextChange
  }, commonProps));
};
Input.propTypes = {
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  inputRef: PropTypes.shape({}),
  innerRef: PropTypes.shape({}),
  isReversed: PropTypes.bool,
  onChange: PropTypes.func,
  onTextChange: PropTypes.func,
  optionKey: PropTypes.string,
  placeholder: PropTypes.string,
  prefixClassName: PropTypes.string,
  text: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.shape({})),
  withMultiple: PropTypes.bool,
  withSearch: PropTypes.bool,
  themed: PropTypes.bool,
  icon: PropTypes.node,
  size: PropTypes.string
};
Input.defaultProps = {
  disabled: false,
  focused: false,
  isReversed: false,
  withMultiple: false,
  withSearch: false,
  onChange: function onChange() {},
  onTextChange: function onTextChange() {},
  optionKey: "",
  placeholder: "",
  prefixClassName: "",
  tooltip: "",
  text: "",
  themed: false,
  size: ""
};
Input.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Input",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "focused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isReversed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withMultiple": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withSearch": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onTextChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "optionKey": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tooltip": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "text": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "inputRef": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false,
      "description": ""
    },
    "icon": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$4 = ".WithCheckboxInput_withCheckboxInput__3T6S_ {\n  font-family: \"Proxima Nova\", sans-serif;\n  display: flex;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  position: relative;\n  justify-content: space-between;\n  padding: 6px 8px;\n  box-sizing: border-box;\n  transition: 0.2s ease-out;\n  background: #fff; }\n  .WithCheckboxInput_withCheckboxInput__3T6S_.WithCheckboxInput_focused__1X6y0:not(.WithCheckboxInput_reversed__1zACS) {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0; }\n  .WithCheckboxInput_withCheckboxInput__3T6S_.WithCheckboxInput_focused__1X6y0.WithCheckboxInput_reversed__1zACS {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n  .WithCheckboxInput_withCheckboxInput__3T6S_.WithCheckboxInput_disabled__1njyj {\n    background-color: #eee;\n    color: #999; }\n  .WithCheckboxInput_withCheckboxInputText__1NdZp {\n    width: 95%;\n    font-size: 14px;\n    padding: 0 8px 0 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-family: \"Proxima Nova\", sans-serif; }\n  .WithCheckboxInput_withCheckboxInputIcon__1qJ6f {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    width: 5%; }\n";
var styles$4 = {"withCheckboxInput":"WithCheckboxInput_withCheckboxInput__3T6S_","focused":"WithCheckboxInput_focused__1X6y0","reversed":"WithCheckboxInput_reversed__1zACS","disabled":"WithCheckboxInput_disabled__1njyj","withCheckboxInputText":"WithCheckboxInput_withCheckboxInputText__1NdZp","withCheckboxInputIcon":"WithCheckboxInput_withCheckboxInputIcon__1qJ6f"};
styleInject(css_248z$4);

var WithCheckboxInput = function WithCheckboxInput(_ref) {
  var value = _ref.value,
    innerRef = _ref.innerRef,
    optionKey = _ref.optionKey,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    tooltip = _ref.tooltip,
    focused = _ref.focused,
    isReversed = _ref.isReversed,
    prefixClassName = _ref.prefixClassName,
    themed = _ref.themed,
    icon = _ref.icon;
  var _React$useContext = React.useContext(Context),
    primaryColor = _React$useContext.primaryColor;
  var focusedStyle = focused ? {
    borderColor: primaryColor
  } : {};
  var focusedClassName = focused ? styles$4.focused : "";
  var reversedClassName = isReversed ? styles$4.reversed : "";
  var disabledClassName = disabled ? styles$4.disabled : "";
  var renderWithCheckboxInput = function renderWithCheckboxInput() {
    if (themed) {
      var dropdownVariant = "dropdown";
      if (focused && !disabled) {
        if (isReversed) {
          dropdownVariant = "dropdownActiveTop";
        } else {
          dropdownVariant = "dropdownActive";
        }
      }
      if (disabled) {
        dropdownVariant = "disabled";
      }
      return /*#__PURE__*/React.createElement(DropdownWrapper, {
        ref: innerRef,
        "data-testid": "dropdownCheckboxWrapper"
      }, icon && /*#__PURE__*/React.createElement(DropdownIcon, {
        mode: "withCheckbox"
      }, /*#__PURE__*/React.createElement(Icon, {
        src: icon
      })), /*#__PURE__*/React.createElement(DropdownWithCheckboxInput, {
        variant: dropdownVariant
      }, value.map(function (valueObject) {
        return valueObject[optionKey];
      }).join(", ") || placeholder || "Nothing selected.", tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
        themed: true,
        tooltip: tooltip,
        position: "BOTTOM"
      }, /*#__PURE__*/React.createElement(DropdownArrow, {
        mode: focused ? "active" : "inactive"
      }, /*#__PURE__*/React.createElement(Icon, {
        src: AngleDownIcon
      }))) : /*#__PURE__*/React.createElement(DropdownArrow, {
        mode: focused ? "activeWithCheckbox" : "inactiveWithCheckbox"
      }, /*#__PURE__*/React.createElement(Icon, {
        src: AngleDownIcon
      }))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$4.withCheckboxInput, " ").concat(focusedClassName, " ").concat(reversedClassName, " ").concat(disabledClassName),
      style: focusedStyle,
      ref: innerRef,
      "data-testid": "dropdownCheckboxWrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$4.withCheckboxInputText
    }, value.map(function (valueObject) {
      return valueObject[optionKey];
    }).join(", ")), /*#__PURE__*/React.createElement("div", {
      className: styles$4.withCheckboxInputIcon
    }, tooltip ? /*#__PURE__*/React.createElement(WithTooltip, {
      className: "".concat(prefixClassName, "-tooltip"),
      tooltip: tooltip,
      position: "BOTTOM"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(prefixClassName, "-icon"),
      src: AngleDownIcon
    })) : /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(prefixClassName, "-icon"),
      src: AngleDownIcon
    })));
  };
  return renderWithCheckboxInput();
};
WithCheckboxInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({})),
  innerRef: PropTypes.shape({}),
  optionKey: PropTypes.string,
  placeholder: PropTypes.string,
  tooltip: PropTypes.string,
  prefixClassName: PropTypes.string,
  focused: PropTypes.bool,
  isReversed: PropTypes.bool,
  themed: PropTypes.bool
};
WithCheckboxInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WithCheckboxInput",
  "props": {
    "value": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": ""
    },
    "optionKey": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tooltip": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "focused": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isReversed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

/**
 * getOptions takes some input props and returns
 * the list of options to be rendered by the dropdown component
 * @param {object}    config
 * @param {Object[]}  options         list of options to filter
 * @param {string}    optionKey       the main key for the label. option[optionKey] gives the label
 * @param {string}    noOptionsText   The text to show in case no options are visible
 * @param {string}    createPrefix    In case creation is allowed, then the prefix to append the new text
 * @param {boolean}   withCreate      Whether creation is allowed
 * @param {Object}    value           The currently selected value
 * @param {string}    text            The currently typed value
 * }
 */
function getOptions(_ref) {
  var options = _ref.options,
    optionKey = _ref.optionKey,
    noOptionsText = _ref.noOptionsText,
    createPrefix = _ref.createPrefix,
    withCreate = _ref.withCreate,
    value = _ref.value,
    text = _ref.text,
    _ref$withCheckbox = _ref.withCheckbox,
    withCheckbox = _ref$withCheckbox === void 0 ? false : _ref$withCheckbox,
    _ref$withMultiple = _ref.withMultiple,
    withMultiple = _ref$withMultiple === void 0 ? false : _ref$withMultiple,
    themed = _ref.themed;
  var isUsingCheckbox = withCheckbox && withMultiple;
  // ===first===
  // filter out the already selected options
  // based on the value.
  // ===second===
  // transform the array of objects to a simple array of objects matching
  // the following structure. Each option is an object
  // {
  //   label: text to be displayed
  //   value: the actual value to be returned on change
  //   isNew: is a newly created input
  //   isZeroState: is a zero state option (when no options available)
  // }
  var flatValue = value.map(function (valueItem) {
    return valueItem[optionKey];
  });
  var flatOptions = options.map(function (valueItem) {
    return valueItem[optionKey];
  });
  var filteredOptions = options.filter(function (option) {
    return isUsingCheckbox || !flatValue.includes(option[optionKey]);
  }).map(function (option) {
    return _defineProperty({
      label: option[optionKey],
      value: option
    }, isUsingCheckbox && "isSelected", flatValue.includes(option[optionKey]));
  });

  // if creation is allowed we check if the typed text is the same as an option
  // if not, then we inject an option at the top allowing them to create a value
  if (withCreate && !flatOptions.includes(text) && text.trim()) {
    var _value;
    filteredOptions = [{
      label: !themed ? "".concat(createPrefix, " <strong>").concat(text, "</strong>") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownCreateText, null, createPrefix), /*#__PURE__*/React.createElement(Text, {
        variant: "h4.semi-bold"
      }, text)),
      value: (_value = {}, _defineProperty(_value, optionKey, text), _defineProperty(_value, "type", "CREATE"), _value),
      isNew: true
    }].concat(_toConsumableArray(filteredOptions));
  }

  // if there are no filtered options then we return a zero state which is an array with just
  // the zero state option
  return filteredOptions.length ? filteredOptions : [{
    label: noOptionsText,
    value: null,
    isZeroState: true
  }];
}

var Dropdown = function Dropdown(_ref) {
  var className = _ref.className,
    prefixClassName = _ref.prefixClassName,
    label = _ref.label,
    noOptionsText = _ref.noOptionsText,
    error = _ref.error,
    optionKey = _ref.optionKey,
    value = _ref.value,
    propOptions = _ref.options,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    createPrefix = _ref.createPrefix,
    searchKeys = _ref.searchKeys,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    disabled = _ref.disabled,
    tooltip = _ref.tooltip,
    arrowTooltip = _ref.arrowTooltip,
    withSearch = _ref.withSearch,
    withCreate = _ref.withCreate,
    withMultiple = _ref.withMultiple,
    withCheckbox = _ref.withCheckbox,
    themed = _ref.themed,
    style = _ref.style,
    icon = _ref.icon,
    arrowIcon = _ref.arrowIcon,
    size = _ref.size,
    attachTo = _ref.attachTo;
  // stores the currently typed input (in case of withSearch)
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    text = _React$useState2[0],
    setText = _React$useState2[1];
  var _React$useState3 = React.useState(propOptions),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    options = _React$useState4[0],
    setOptions = _React$useState4[1];

  // updates initial set of options, whenever propOptions changes
  // because on re-render, useState for options doesn't get called, which results in
  // options always using the old value of propOptions.
  React.useEffect(function () {
    setOptions(propOptions);
  }, [propOptions]);
  var _React$useState5 = React.useState(),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    createdOption = _React$useState6[0],
    setCreatedOption = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    focused = _React$useState8[0],
    setFocused = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isSearchFocused = _React$useState10[0],
    setIsSearchFocused = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isMouseOnOptions = _React$useState12[0],
    setIsMouseOnOptions = _React$useState12[1];

  // simple mode is when the options are an array of strings instead of objects
  // and the value and onChange also expect strings.
  var isSimpleInputMode = typeof value === "string";
  var isSimpleOptionsMode = options.length && typeof propOptions[0] === "string";

  // the ref for the input wrapper (used for positioning the dropdown)
  var inputWrapperRef = React.useRef();

  // the ref for blur lock (whether to lock the blur event or not)
  var blurCount = React.useRef(false);

  // the ref for the actual input itself (used for focus/blur of input)
  var inputRef = React.useRef();

  // the ref for the clear timeout
  // [when the typeable input clears]
  var timeoutRef = React.useRef();
  var inputValue = "";
  // if the value is a simple string, convert it to an object
  inputValue = isSimpleInputMode ? _defineProperty({}, optionKey, value) : value;
  // we normalize it to always be an array of objects depending on the useMultiple flag
  inputValue = withMultiple ? inputValue : [inputValue];
  var firstValueLabel = inputValue[0] ? inputValue[0][optionKey] || "" : "";

  // based on the typed text, the options are filtered using the useSearch hook
  // Fuse.js is used for fuzzy searching.
  // searchText is set to empty (show all results if a valid value is already selected)
  // searchKeys determines the array of keys withing the options to search
  var searchInKeys = searchKeys.length ? searchKeys : [optionKey];
  var searchText = text === firstValueLabel ? "" : text;
  var searchResults = useSearch(searchText, options, searchInKeys);

  // we need to normalize the options for display.
  // - It filters out the option that was selected
  // - Injects the zero state in case there are no options
  // - Injects the withCreate option in case creation is allowed
  var dropdownOptions = getOptions({
    options: withSearch || withMultiple ? searchResults : options,
    optionKey: optionKey,
    noOptionsText: noOptionsText,
    withCreate: withCreate,
    createPrefix: createPrefix,
    text: text,
    withCheckbox: withCheckbox,
    withMultiple: withMultiple,
    value: inputValue,
    themed: themed,
    size: size
  });
  var attachToElementHeight = attachTo && attachTo.current && attachTo.current.getBoundingClientRect().height;
  // To determine whether the dropdown options container opens above the dropdown
  // or below.
  // The 200 is the max height of the dropdown. (To account for some space for the dropdown to open)
  var inputWrapperBottom = inputWrapperRef.current && inputWrapperRef.current.getBoundingClientRect().bottom || 0;

  // In case of attachTo is provided, finding relative top
  var isReversed = (attachTo && attachTo.current ? inputWrapperBottom - attachTo.current.getBoundingClientRect().top : inputWrapperBottom) + 200 > (attachToElementHeight || window.innerHeight);

  // on blurring we clear + blur the input
  var handleBlur = function handleBlur(e) {
    if (disabled) return;
    if (withMultiple && withCheckbox && isMouseOnOptions) {
      handleFocus(e);
      return;
    }
    setFocused(false);
    onBlur(e);
    if (inputRef.current) inputRef.current.blur();

    // increment the blur count
    blurCount.current += 1;
    var target = e.target;

    // clear search if search with useChecbox
    if (withCheckbox && withSearch && withMultiple) {
      setText("");
    }

    // If onClick event fire, we don't need to set value to old value
    // value of blurCount will be incresed to 2 in onMouseDown event
    // otherwise it will reset the text to the old value.
    if (text !== firstValueLabel && target && blurCount.current === 1) {
      var optionIndex = dropdownOptions.map(function (option) {
        return option.label;
      }).indexOf(text);
      if (withMultiple) setText("");else if (optionIndex > -1) onChange(dropdownOptions[optionIndex].value);else setText(firstValueLabel);
    }
  };
  var handleFocus = function handleFocus(e) {
    if (disabled) return;
    setFocused(true);
    onFocus(e);

    // blur count keeps track of how many times the blur event was called
    // this is to ensure that the when the user clicks on the option
    // we can ignore the duplicate blur event
    blurCount.current = 0;

    // sometimes the input isn't immediately available
    // only available on the next tick (hence the timeout is 0)
    setTimeout(function () {
      inputRef.current && inputRef.current.focus();
    }, 0);
    clearTimeout(timeoutRef.current);
  };

  // when user click on the option from dropdown, onMouseDown event will get fire
  // we can ignore the duplicate blur event
  var onMouseDown = function onMouseDown() {
    blurCount.current += 1;
  };
  var handleChange = function handleChange(e) {
    // if it's simple mode, then we return a string value
    onChange(isSimpleOptionsMode ? e[optionKey] : e);
    // we don't blur if multiple options can be selected
    // this is a UX decision.
    if (!withMultiple) {
      handleBlur(e);
    } else if (!withCheckbox) setText("");

    // if we allow creation and the new option selected
    // is a new option (does not exist in the options list)
    // then we set the temp option to store the new option so that it's there in the
    // dropdown
    if (withCreate && !dropdownOptions.map(function (option) {
      return option.label;
    }).includes(e[optionKey])) {
      setCreatedOption(e);
    }
  };
  var handleOptionClick = function handleOptionClick(e) {
    // based on if multiple selection is allowed
    // then we append the new option to the existing value array
    // otherwise we return the value as is

    var newValue;
    if (withCheckbox && withMultiple) {
      var isValueAlreadyPresent = inputValue.filter(function (value) {
        return value[optionKey] === e[optionKey];
      }).length;
      if (isValueAlreadyPresent) {
        newValue = inputValue.filter(function (value) {
          return value[optionKey] !== e[optionKey];
        });
      } else {
        newValue = [].concat(_toConsumableArray(inputValue), [e]);
      }
    } else if (withMultiple) {
      newValue = [].concat(_toConsumableArray(inputValue), [e]);
    } else {
      newValue = e;
    }
    handleChange(newValue);
  };
  var handleOnSearchFocus = function handleOnSearchFocus() {
    setIsSearchFocused(true);
  };
  var handleOnSearchBlur = function handleOnSearchBlur() {
    setIsSearchFocused(false);
  };
  var handleSearchText = function handleSearchText(text) {
    setText(text);
  };
  React.useEffect(function () {
    // we also support an array of strings instead of objects
    // we normalize it to objects with the default optionKey
    // [simple mode]
    var listOfOptionObjects = propOptions;
    if (isSimpleOptionsMode) {
      listOfOptionObjects = propOptions.map(function (option) {
        return _defineProperty({}, optionKey, option);
      });
    }

    // merged options contains the extra created option if available
    var mergedOptions = createdOption && withCreate ? [createdOption].concat(_toConsumableArray(listOfOptionObjects)) : listOfOptionObjects;
    setOptions(mergedOptions);
  }, [propOptions, propOptions.length, createdOption, isSimpleOptionsMode, optionKey, withCreate]);
  React.useEffect(function () {
    // we set the search text for single selection
    // items to the selected value. This is so that
    // the input text shows the selected value
    if (withMultiple) return;
    setText(firstValueLabel || "");
  }, [firstValueLabel, withMultiple]);
  var mouseEnter = function mouseEnter() {
    withCheckbox && withMultiple && setIsMouseOnOptions(true);
  };
  var mouseLeave = function mouseLeave() {
    withCheckbox && withMultiple && setIsMouseOnOptions(false);
  };
  var renderDropdown = function renderDropdown() {
    if (themed) {
      return /*#__PURE__*/React.createElement(DropdownWrapper, {
        "data-testid": "dropdown",
        tabIndex: "0",
        onFocus: handleFocus,
        onBlur: handleBlur,
        style: style
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "h4.semi-bold",
        color: error && "red.haptik"
      }, label, " ", error && " (".concat(error, ")")), withMultiple && withCheckbox ? /*#__PURE__*/React.createElement(WithCheckboxInput, {
        innerRef: inputWrapperRef,
        value: inputValue,
        optionKey: optionKey,
        placeholder: placeholder,
        tooltip: arrowTooltip,
        disabled: disabled,
        focused: focused,
        isReversed: isReversed,
        icon: icon,
        size: size,
        themed: true
      }) : /*#__PURE__*/React.createElement(Input, {
        innerRef: inputWrapperRef,
        inputRef: inputRef,
        value: inputValue,
        text: text,
        onTextChange: setText,
        onChange: handleChange,
        isReversed: isReversed,
        focused: focused,
        tooltip: arrowTooltip,
        placeholder: placeholder,
        withSearch: withSearch,
        withMultiple: withMultiple,
        optionKey: optionKey,
        disabled: disabled,
        icon: icon,
        arrowIcon: arrowIcon,
        size: size,
        themed: true
      }), /*#__PURE__*/React.createElement(Options, {
        attachTo: inputWrapperRef,
        attachPortalTo: attachTo,
        inputRef: inputRef,
        focused: focused,
        options: dropdownOptions,
        onChange: handleOptionClick,
        onMouseDown: onMouseDown,
        handleOnSearchFocus: handleOnSearchFocus,
        handleOnSearchBlur: handleOnSearchBlur,
        handleSearchText: handleSearchText,
        isSearchFocused: isSearchFocused,
        isReversed: isReversed,
        onBlur: handleBlur,
        prefixClassName: prefixClassName,
        withSearch: withSearch,
        withMultiple: withMultiple,
        onMouseEnter: mouseEnter,
        onMouseLeave: mouseLeave,
        withCheckbox: withCheckbox,
        size: size,
        themed: true,
        noOptionsText: noOptionsText
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$3.dropdown, " ").concat(prefixClassName, " ").concat(className),
      "data-testid": "dropdown",
      tabIndex: "0",
      onFocus: handleFocus,
      onBlur: handleBlur
    }, /*#__PURE__*/React.createElement(Label, {
      focused: focused,
      error: error,
      tooltip: tooltip,
      className: "".concat(styles$3.dropdownLabel, " ").concat(prefixClassName, "-label ").concat(prefixClassName, "-error")
    }, label), withMultiple && withCheckbox ? /*#__PURE__*/React.createElement(WithCheckboxInput, {
      innerRef: inputWrapperRef,
      value: inputValue,
      optionKey: optionKey,
      tooltip: arrowTooltip,
      disabled: disabled,
      focused: focused,
      isReversed: isReversed,
      prefixClassName: "".concat(prefixClassName, "-input")
    }) : /*#__PURE__*/React.createElement(Input, {
      innerRef: inputWrapperRef,
      inputRef: inputRef,
      value: inputValue,
      text: text,
      onTextChange: setText,
      onChange: handleChange,
      isReversed: isReversed,
      focused: focused,
      tooltip: arrowTooltip,
      placeholder: placeholder,
      withSearch: withSearch,
      withMultiple: withMultiple,
      optionKey: optionKey,
      disabled: disabled,
      prefixClassName: "".concat(prefixClassName, "-input")
    }), /*#__PURE__*/React.createElement(Options, {
      attachTo: inputWrapperRef,
      inputRef: inputRef,
      focused: focused,
      options: dropdownOptions,
      onChange: handleOptionClick,
      onMouseDown: onMouseDown,
      handleOnSearchFocus: handleOnSearchFocus,
      handleOnSearchBlur: handleOnSearchBlur,
      handleSearchText: handleSearchText,
      isSearchFocused: isSearchFocused,
      isReversed: isReversed,
      onBlur: handleBlur,
      prefixClassName: prefixClassName,
      withSearch: withSearch,
      withMultiple: withMultiple,
      onMouseEnter: mouseEnter,
      onMouseLeave: mouseLeave,
      withCheckbox: withCheckbox
    }));
  };
  return renderDropdown();
};
Dropdown.propTypes = {
  /** Placeholder Text for the Dropdown */
  placeholder: PropTypes.string,
  /** ClassName for the Dropdown element */
  className: PropTypes.string,
  /** Value of the Dropdown Input */
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  /** Label for the Dropdown */
  label: PropTypes.string,
  /** Text to be shown if there are no options */
  noOptionsText: PropTypes.string,
  /** Error for Dropdown */
  error: PropTypes.string,
  /** Key to sort for option */
  optionKey: PropTypes.string,
  /** onChange Callback */
  onChange: PropTypes.func,
  /** Options for The Dropdown */
  options: PropTypes.array,
  /** PrefixClassName for The Dropdown */
  prefixClassName: PropTypes.string,
  /** Text to prefix for Creating a new option */
  createPrefix: PropTypes.string,
  /** onFocus Callback */
  onFocus: PropTypes.func,
  /** onBlur Callback */
  onBlur: PropTypes.func,
  /** Dropdown with Search Enabled */
  withSearch: PropTypes.bool,
  /**  Dropdown with Creating new Options Enabled */
  withCreate: PropTypes.bool,
  /**  Dropdown with Multiple Inputs Enabled */
  withMultiple: PropTypes.bool,
  /**  Whether the input is disabled or not */
  disabled: PropTypes.bool,
  /** Tooltip any if required (gets attached to the label) */
  tooltip: PropTypes.string,
  /** tooltip any if required (gets attached to the arrow icon) */
  arrowTooltip: PropTypes.string,
  /**  Keys in the options to search for when using withSearch */
  searchKeys: PropTypes.arrayOf(PropTypes.string),
  /** Flag to use checkbox style of dropdown (NOTE: Can be only used withMultiple flag) */
  withCheckbox: PropTypes.bool,
  /** Whether the dropdown will be themed */
  themed: PropTypes.bool,
  /** prefix Icon */
  icon: PropTypes.node,
  /** arrow Icon */
  arrowIcon: PropTypes.node,
  /** attach to */
  attachTo: PropTypes.shape({
    current: PropTypes.node
  })
};
Dropdown.defaultProps = {
  className: "",
  prefixClassName: "",
  label: "",
  noOptionsText: "No options present",
  error: "",
  optionKey: "text",
  value: [],
  options: [],
  onChange: function onChange() {},
  placeholder: "",
  tooltip: "",
  arrowTooltip: "",
  createPrefix: "+ Create",
  searchKeys: [],
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  disabled: false,
  withSearch: false,
  withCreate: false,
  withMultiple: false,
  withCheckbox: false,
  themed: false,
  icon: null,
  attachTo: null,
  arrowIcon: null
};
Dropdown.classNames = {
  $prefix: "Prefix ClassName",
  "$prefix-label": "Prefix ClassName applied to the Label",
  "$prefix-input": "Prefix ClassName applied to the input element",
  "$prefix-input-icon": 'Prefix ClassName applied to the "arrow down" icon',
  "$prefix-error": "Prefix ClassName applied in case of error",
  "$prefix-options": "Prefix ClassName applied to the options container",
  "$prefix-option": "Prefix ClassName applied to the individual option"
};
Dropdown.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dropdown",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "ClassName for the Dropdown element"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "PrefixClassName for The Dropdown"
    },
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for the Dropdown"
    },
    "noOptionsText": {
      "defaultValue": {
        "value": "\"No options present\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text to be shown if there are no options"
    },
    "error": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Error for Dropdown"
    },
    "optionKey": {
      "defaultValue": {
        "value": "\"text\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Key to sort for option"
    },
    "value": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "shape",
          "value": {}
        }, {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {}
          }
        }]
      },
      "required": false,
      "description": "Value of the Dropdown Input"
    },
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Options for The Dropdown"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onChange Callback"
    },
    "placeholder": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder Text for the Dropdown"
    },
    "tooltip": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Tooltip any if required (gets attached to the label)"
    },
    "arrowTooltip": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "tooltip any if required (gets attached to the arrow icon)"
    },
    "createPrefix": {
      "defaultValue": {
        "value": "\"+ Create\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text to prefix for Creating a new option"
    },
    "searchKeys": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Keys in the options to search for when using withSearch"
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onFocus Callback"
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onBlur Callback"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether the input is disabled or not"
    },
    "withSearch": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Dropdown with Search Enabled"
    },
    "withCreate": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Dropdown with Creating new Options Enabled"
    },
    "withMultiple": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Dropdown with Multiple Inputs Enabled"
    },
    "withCheckbox": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Flag to use checkbox style of dropdown (NOTE: Can be only used withMultiple flag)"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether the dropdown will be themed"
    },
    "icon": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "prefix Icon"
    },
    "attachTo": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "node",
            "required": false
          }
        }
      },
      "required": false,
      "description": "attach to"
    },
    "arrowIcon": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "arrow Icon"
    }
  }
};

export { AUDIO_EXTENSIONS as A, Checkbox as C, Dropdown as D, ENDPOINTS as E, IMAGE_EXTENSIONS as I, VIDEO_EXTENSIONS as V };
